import styled from "styled-components";

export const StyledTextAreaBox = styled.div`
  overflow-wrap: anywhere;
  white-space: pre-wrap;

  span {
    display: block;
    align-items: unset;
  }
`;
